<template lang="pug">
.section.content.has-text-centered
  div.margin-top-40
    img(src="png/welcome-client.png")
  div.margin-top-40
    div Personal training at {{ title }}{{ isOperator ? ',' : '' }}
    div {{ isOperator ? 'powered by Go:Do Fitness' : '' }}
  div.margin-top-40
    .field
      .control
        .buttons.is-centered
          a.button.is-primary(href="/sign-up") Create Account
    .field
      .control
        .buttons.is-centered
            a.button(href="/log-in") Log In
  div.margin-top-40
    div By signing up, you agree to
    div our #[router-link(to="/terms") terms] and #[router-link(to="/privacy-policy") privacy policy].
</template>

<script>
import Constants from '@/constants'

export default {
  computed: {
    isOperator () {
      return Constants.OPERATOR !== 3
    },
    title () {
      return Constants.TITLE
    }
  }
}
</script>
